import { ShieldAlert } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function UnauthorizedPage({
  requiredRole,
  activeRole,
}: {
  requiredRole: string
  activeRole: string | null
}) {
  return (
    <div className="mx-auto max-w-2xl px-4 py-10">
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <ShieldAlert className="mt-0.5 h-5 w-5 text-amber-700" />
          <div>
            <h1 className="text-xl font-semibold text-stone-900">Access denied</h1>
            <p className="mt-2 text-sm text-stone-700">
              This page requires the <span className="font-medium">{requiredRole}</span> role.
              {activeRole ? (
                <>
                  {' '}
                  You are currently operating as <span className="font-medium">{activeRole}</span>.
                </>
              ) : null}
            </p>
            <p className="mt-2 text-sm text-stone-600">
              Switch to the required staff role if it is assigned to your account, or return to your
              current workspace.
            </p>
            <div className="mt-4">
              <Link
                to="/notifications"
                className="inline-flex rounded bg-stone-900 px-4 py-2 text-sm font-medium text-white hover:bg-stone-800"
              >
                Go to shared workspace
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
